<template>
  <ul
    v-if="payments.length"
    class="payment-icons"
    :class="[
      $blockClass(blockClass, 'payment-icons'),
      { 'payment-icons--center': center },
    ]"
  >
    <li
      v-for="(payment) in payments"
      :key="`payment-${payment.type}`"
      class="payment-icons__icon"
      :class="$blockClass(blockClass, 'payment-icon')"
      :arial-label="payment.type"
      v-html="payment.icon"
    />

    <li
      v-if="klarnaIcon"
      class="payment-icons__icon"
      :class="$blockClass(blockClass, 'payment-icon')"
      :aria-label="$string('accessibility.klarna_payment')"
    >
      <icon-klarna />
    </li>

    <li
      v-if="clearpayIcon"
      class="payment-icons__icon"
      :class="$blockClass(blockClass, 'payment-icon')"
      :aria-label="$string('accessibility.clearpay_payment')"
    >
      <icon-clearpay />
    </li>

    <li
      v-if="revolutIcon"
      class="payment-icons__icon"
      :class="$blockClass(blockClass, 'payment-icon')"
      :aria-label="$string('accessibility.revolut_payment')"
    >
      <icon-revolut />
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Payment icons (payment-icons)
 * -----------------------------------------------------------------------------
 * Displays payment icons for enabled payment gateway.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean} [center] - Center icons.
 * @param {Array} payments - Array of payment icons and type.
 * @param {Boolean} klarnaIcon - Klarna icon status.
 * @param {Boolean} clearpayIcon - Clearpay icon status.
 *
 */
import IconKlarna from '~icons/payment/klarna.svg'
import IconClearpay from '~icons/payment/clearpay.svg'
import IconRevolut from '~icons/payment/revolut.svg'

export default {
  name: 'PaymentIcons',

  components: {
    IconKlarna,
    IconClearpay,
    IconRevolut,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    center: {
      type: Boolean,
      default: false,
    },
    payments: {
      type: Array,
      default: () => ([]),
      required: true,
    },
    klarnaIcon: {
      type: Boolean,
      default: true,
    },
    clearpayIcon: {
      type: Boolean,
      default: true,
    },
    revolutIcon: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
@import './payment-icons';
</style>
